module.exports = __webpack_public_path__ + "static/media/03.cdc5fa57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/camera/03.png
// module id = 632
// module chunks = 0